import { GuardedComponent } from '../components/guarded-component';
import { OperationManagementPage } from '../features/operation-management/operation-management.page';
import { UserPermissionName } from '../models/user-permission-name';

export const OperationManagementRoute = {
  path: '/operation-management',
  children: [
    {
      index: true,
      element: (
        <GuardedComponent requiredPermissions={[UserPermissionName.VIEW_OPERATIONMANAGEMENT]} showPermissionError>
          <OperationManagementPage />
        </GuardedComponent>
      ),
    },
  ],
};
